export const productDetailFiltersAndConfigurationsQuery = `
query ProductDetailFiltersAndConfigurations(
$filterCriteria:ConfigurationCriteria
$configurationCriteria:ConfigurationCriteria
){
  configurations(criteria: $configurationCriteria, bestOnePer: [product, customerGroup, term]) {
    __typename
    id
    orderCode
    supportsSubscriptions
    title
    product {
      id
    }
    modality {
      id
    }
    customerGroup {
      id
    }
    term {
      id
    }
    price {
      amount
      currency
    }
    pricePerYear {
      amount
      currency
    }
    validityPeriod {
      start
      end
    }
  }
  filters: filters(criteria: $filterCriteria) {
    customerGroups {
      id
      title
      nrOfProductConfigurations
      isDefault
      order
      deeplinkId
    }
    classes {
      id
      title
      nrOfProductConfigurations
      deeplinkId
      order
    }
    terms {
      id
      title
      termsPerYear
      nrOfProductConfigurations
      deeplinkId
    }
    stops {
      id
      title
      nrOfProductConfigurationsAsFromStop
      nrOfProductConfigurationsAsToStop
      deeplinkId
    }
    zones {
      id
      title
      nrOfProductConfigurations
      code
      deeplinkId
    }
    starValues {
      id
      title
      nrOfProductConfigurations
      deeplinkId
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/products-api/queries/product-detail-filters-and-configurations.js